export const VerificationIcon = () => {
	return (
		<svg
			width="327"
			height="200"
			viewBox="0 0 327 200"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="327" height="200" fill="white" />
			<path
				d="M96.4609 52.84C102.055 68.0621 101.66 87.1549 100.764 94.7985C95.3857 188.473 156.7 192.864 187.357 187.498C218.015 182.131 238.453 126.024 244.37 118.217C250.286 110.411 258.892 79.674 259.967 57.7189C261.043 35.7639 235.226 43.5701 214.25 48.449C193.274 53.3279 163.154 32.8365 140.564 21.1271C117.974 9.41776 110.983 10.3935 100.764 11.8572C90.5445 13.3209 89.4688 33.8123 96.4609 52.84Z"
				fill="#F4F9F5"
			/>
			<g>
				<path
					d="M128.168 49.0968C139.071 51.6867 160.281 56.0341 169.523 57.884C218.397 68.4688 222.627 94.4207 237.196 131.42C251.764 168.419 221.688 182.294 194.431 180.906C167.174 179.519 111.72 158.707 98.0913 140.207C84.4629 121.708 65.665 101.358 67.0749 67.1338C68.4847 32.9096 114.539 45.8593 128.168 49.0968Z"
					fill="#6FDB89"
					fillOpacity="0.17"
				/>
			</g>
			<path
				d="M115.786 60.7167L162.69 44.4543C163.538 44.16 164.462 44.16 165.31 44.4543L212.214 60.7167C213.871 61.2911 214.959 62.8282 214.849 64.5781C213.849 80.5321 206.825 157 164 157C121.175 157 114.151 80.5321 113.151 64.5781C113.041 62.8282 114.129 61.2911 115.786 60.7167Z"
				fill="#DCE3F9"
				stroke="#1C308B"
				strokeWidth="4"
			/>
			<path
				d="M137.414 105.586L142.69 100.31C143.429 99.5706 144.613 99.5252 145.406 100.205L156.594 109.795C157.387 110.475 158.571 110.429 159.31 109.69L188.586 80.4142C189.367 79.6332 190.633 79.6332 191.414 80.4142L197.586 86.5858C198.367 87.3668 198.367 88.6332 197.586 89.4142L159.414 127.586C158.633 128.367 157.367 128.367 156.586 127.586L137.414 108.414C136.633 107.633 136.633 106.367 137.414 105.586Z"
				fill="white"
				stroke="#1C308B"
				strokeWidth="4"
			/>
			<path
				d="M76 175H252"
				stroke="#1C308B"
				strokeWidth="4"
				strokeLinecap="round"
			/>
		</svg>
	);
};
